module.exports = __webpack_public_path__ + "img/a8b551c.jpg";